import { VoltageSpeedHistoricalBaseline, VoltageSpeedStateSummary } from '../../voltage-with-speed.models';

function validNumber(value: unknown): number | null {
  return typeof value === 'number' && Number.isFinite(value) && value >= 0 ? value : null;
}

export function buildHistoricalBaseline(baselines: VoltageSpeedHistoricalBaseline[], states: VoltageSpeedStateSummary[]) {
  return baselines.filter(baseline => Number.isInteger(baseline.StateID) && baseline.StateID >= 0).map(baseline => {
    const today = states.find(state => state.StateID === baseline.StateID);
    const samples = Number.isInteger(baseline.BaselineSamples) ? validNumber(baseline.BaselineSamples) : null;
    const historicalAverage = samples !== null && samples > 0 ? validNumber(baseline.BaselineAvg) : null;
    const todayAverage = today && validNumber(today.RecordCount) !== null && today.RecordCount > 0 ? validNumber(today.AvgVoltage) : null;
    const deviation = validNumber(baseline.BaselineStdDev);
    const difference = historicalAverage !== null && todayAverage !== null ? todayAverage - historicalAverage : null;
    const reliable = typeof baseline.IsReliable === 'boolean' ? baseline.IsReliable : null;
    const zScore = reliable && difference !== null && deviation !== null && deviation > 0 ? difference / deviation : null;
    return {
      stateID: baseline.StateID,
      label: ['موتور خاموش', 'درجا روشن', 'در حال حرکت'][baseline.StateID] || `وضعیت ${baseline.StateID}`,
      samples,
      historicalAverage,
      todayAverage,
      deviation,
      difference,
      reliable,
      zScore: zScore !== null && Number.isFinite(zScore) ? zScore : null
    };
  });
}
